import { InjectionToken } from "@angular/core";

export const API_URL = new InjectionToken<string>('API_URL');
export const IMAGE_URL = new InjectionToken<string>('IMAGE_URL');